import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from '../lib/axios';
import Modal from './Modal';
import ReactRailsUJS from "../lib/react-rails";

export default class PreviewSurveyButton extends Component {
  static propTypes = {
    buttonLabel: PropTypes.string,
    buttonClassName: PropTypes.string,
    buttonIcon: PropTypes.string,
    buttonIconClassName: PropTypes.string,
    url: PropTypes.string,
    formSelector: PropTypes.string,
    method: PropTypes.string,
  };

  static defaultProps = {
    buttonLabel: '',
    buttonClassName: '',
    buttonIcon: null,
    buttonIconClassName: '',
    url: null,
    formSelector: null,
    method: 'post',
  }

  constructor(props) {
    super(props);

    this.buttonRef = React.createRef();
    this.state = {
      modalTriggered: false,
      modalContent: null,
    };
  }

  handleClick = (e) => {
    if (this.buttonRef.current.contains(e.target)) {
      const { url, formSelector } = this.props;
      const formData = formSelector ? new FormData(document.querySelector(formSelector)) : null;

      axios
        .request({ url, method: this.props.method, data: formData })
        .then((response) => {
          this.setState({ modalTriggered: true, modalContent: response.data }, () => {
            ReactRailsUJS.mountComponents('#modal-container');
            window.Union.setupWizard('#modal-container');
            window.Union.initializeTippy();
            $('#preview .Form')
              .on('submit', (e) => {
                e.preventDefault();
                e.stopPropagation();
              })
              .find('button[type=submit], input[type=submit]')
              .hide()
              .addClass('u-invisible')
              .attr('disabled', 'disabled');
          });
        });
      e.preventDefault();
    }
  }

  handleClose = () => {
    this.setState({ modalTriggered: false });
  }

  render() {
    const { buttonLabel, buttonClassName, buttonIcon, buttonIconClassName } = this.props;

    return (
      <button ref={this.buttonRef} onClick={this.handleClick} className={buttonClassName} type="button">
        {buttonIcon && <i className={`${buttonIcon} ${buttonIconClassName}`} />}
        {buttonLabel}
        { this.state.modalTriggered &&
          <Modal onClose={this.handleClose.bind(this)}>
            <div className="ModalContainer u-relative reveal-modal open" id="modal-container" dangerouslySetInnerHTML={{ __html: this.state.modalContent }} />
          </Modal>
        }
      </button>
    );
  }
}
